import LegalLayout from "@/pages/legal/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" eyebrow="// Legal">
      <p>Lucas Trans Inc. ("we", "us", "our") operates <strong>lucastransinc.com</strong> and provides freight transportation services. This Privacy Policy explains what information we collect, how we use it, and the choices you have.</p>

      <h2>1. Information we collect</h2>
      <ul>
        <li><strong>Contact information</strong> you submit through our website (name, email, phone, company, message).</li>
        <li><strong>Freight quote details</strong> (origin, destination, equipment type, weight, pickup date, commodity, notes).</li>
        <li><strong>Driver application data</strong> (full name, city/state, phone, email, CDL class, years of experience, endorsements, current employment, resume link) — collected only after you explicitly accept the Driver Data Consent statement.</li>
        <li><strong>Technical data</strong> — server logs, timestamps and coarse geolocation from your IP address for basic security and traffic analysis.</li>
      </ul>

      <h2>2. How we use it</h2>
      <ul>
        <li>To respond to freight quote requests, contact messages, and driver applications.</li>
        <li>To operate, maintain and improve the website and dispatch service.</li>
        <li>To meet legal, regulatory, tax, safety and DOT reporting obligations.</li>
      </ul>

      <h2>3. How we share it</h2>
      <p>We do not sell your personal information. We share limited data only with vetted service providers that help us run the business — for example, transactional email delivery (Resend), object storage (Emergent Object Storage) and, if enabled, SMS delivery (Twilio). Each provider processes data on our behalf under a data-processing agreement.</p>

      <h2>4. How long we keep it</h2>
      <p>Contact messages and freight quote requests are retained for up to <strong>24 months</strong>. Driver application data is retained for up to <strong>3 years</strong> unless a longer retention period is required by law. You may request earlier deletion at any time by emailing us.</p>

      <h2>5. Your rights</h2>
      <p>You have the right to request access to, correction of, or deletion of your personal information. Email <a href="mailto:office@lucastransinc.com">office@lucastransinc.com</a> and we will respond within 30 days.</p>

      <h2>6. Security</h2>
      <p>Data is transmitted over TLS, stored in a managed MongoDB instance, and access to admin tools is protected by JWT-based authentication with strong password hashing (bcrypt). No system is 100% secure, and you should never send us your password, card details or full SSN by email.</p>

      <h2>7. Cookies</h2>
      <p>We use only strictly-necessary session storage (JWT admin token). We do not use tracking cookies for advertising.</p>

      <h2>8. Children</h2>
      <p>Our services are directed at businesses and adult professional drivers. We do not knowingly collect information from anyone under 18.</p>

      <h2>9. Contact</h2>
      <p>Lucas Trans Inc. · Hoffman Estates, Illinois · <a href="mailto:office@lucastransinc.com">office@lucastransinc.com</a></p>

      <p className="text-xs text-slate-500 mt-8">Effective: February 2026 · This policy may be updated; the current version always lives at this URL.</p>
    </LegalLayout>
  );
}
